enum ProfileAvatarSizesEnum {
  XS = 'xs',
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  XL = 'xl',
}

export default ProfileAvatarSizesEnum;
